import { withTranslation } from 'react-i18next';
import ErrorPage from './ErrorPage';

export default withTranslation()(ErrorPage);
